/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterApiKeyResponse
 */
export interface RegisterApiKeyResponse {
    /**
     * Whether the registration was successful
     * @type {boolean}
     * @memberof RegisterApiKeyResponse
     */
    success?: boolean;
}

/**
 * Check if a given object implements the RegisterApiKeyResponse interface.
 */
export function instanceOfRegisterApiKeyResponse(value: object): value is RegisterApiKeyResponse {
    let isInstance = true;

    return isInstance;
}

export function RegisterApiKeyResponseFromJSON(json: any): RegisterApiKeyResponse {
    return RegisterApiKeyResponseFromJSONTyped(json, false);
}

export function RegisterApiKeyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterApiKeyResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': !exists(json, 'success') ? undefined : json['success'],
    };
}

export function RegisterApiKeyResponseToJSON(value?: RegisterApiKeyResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
    };
}

